import mcpImg from 'common/assets/images/mixpanel-mcp-min.webp';
import {Translatable} from 'common/i18n';
import {Directions} from 'common/components/drop-menu/types';

export interface TourStepData {
  title: Translatable;
  description: Translatable;
  tourImage?: string;
  tourImageHeight?: string;
  secondaryDescription?: Translatable;
  secondaryDescriptionFontSize?: string;
  tertiaryDescription?: Translatable;
  primaryButtonText?: Translatable;
  primaryButtonLink?: string;
  secondaryButtonText?: Translatable;
  secondaryButtonLink?: string;
  displayDismissButton?: boolean;
  dismissButtonText?: Translatable;
  onClickPrimaryButton?: () => void;
}

export interface TourData {
  stepData: TourStepData[];
  expirationDate?: Date;
  featureGateTier?: string[];
  maxWidth?: string;
  includeFirstStepInStepCount?: boolean;
  direction?: Directions;
}

export enum TourName {
  SPARK_COPILOT = `spark-copilot-beta-2026-05-08`,
  COMMENTS_TOUR = `comments-tour`,
  VERSION_HISTORY_TOUR = `version-history-tour`,
  MCP_GA = `mcp-ga`,
}

export const TOURS = {
  [TourName.MCP_GA]: {
    stepData: [
      {
        title: ({t}) => t(`tours.mcp-ga.title`),
        description: ({t}) => t(`tours.mcp-ga.description`),
        tourImage: mcpImg,
        primaryButtonText: ({t}) => t(`tours.mcp-ga.cta`),
        primaryButtonLink: `https://docs.mixpanel.com/docs/features/mcp?utm_source=product&utm_medium=tour_modal&utm_campaign=mcp_ga#overview`,
        displayDismissButton: true,
      },
    ],
    expirationDate: new Date(`2027-04-10T23:59:59Z`),
  },
} as const satisfies Record<
  Exclude<TourName, TourName.SPARK_COPILOT | TourName.COMMENTS_TOUR | TourName.VERSION_HISTORY_TOUR>,
  TourData
>;
